import {useEffect, useContext, useState, useRef} from 'react';
import Search from "components/Center/Search";
import Form from "components/Center/Form";
import Table from "components/Center/Table";
import WarehouseContext from 'context/WarehouseContext';
import {useCenter} from 'hooks/useCenter';

import {
    getAll as getAllWarehouses
} from "services/WarehouseService.js";

import {useDepartament} from 'hooks/useDepartament';
import SpinnerBootrap from 'components/SpinnerBootrap';

function Center(){
 const {
     centers, 
     loading, 
     page, 
     totalPages, 
     status, 
     deleteCenter, 
     updateCenter, 
     createCenter, 
     getCenters, 
     setPage,
     itemsPerPage,
     setItemsPerPage,
     allCenters,
} = useCenter();

 const searchFormRef = useRef();

 const {allWarehouses, setAllWarehouses} = useContext(WarehouseContext);
 const {allDepartaments} = useDepartament();

 const [isSearched, setIsSearched] = useState({
     search: '',
     option: '',
     state: false
 })

 const getWarehouses = async ({page, limit, code, name}) => {
  try{
   const allWarehouses = await getAllWarehouses({page, limit, code, name});
   setAllWarehouses(allWarehouses)
  }catch(err){
//    const {data, status} = err.response;
//    setMessage({message: data.message, status});
  }
 }

 const resetSearch = () => {
  searchFormRef.current?.reset();
  setIsSearched({
      search: '',
      option: '',
      state: false
  })
 }

 useEffect(() => {
    getWarehouses({});
    // eslint-disable-next-line
 }, [])

 useEffect(() => {
    if(status !== 401 ) return
    localStorage.removeItem('token')
    window.location.href="/login"
 }, [status])
 
 return (
 <div className="container">
     <div className="row my-md-4">
         <h4 className="d-flex justify-content-center">Mantenedor de Centros/Agentes</h4>
         <div className="col-12">
             <Search getCenters={getCenters} setIsSearched={setIsSearched} formRef={searchFormRef}/>
         </div>
         <div className="col-12">
             <Form createCenter={createCenter} updateCenter={updateCenter} allWarehouses={allWarehouses} allDepartaments={allDepartaments} setIsSearched={setIsSearched}/>
         </div>
         <div className="col-12">
             {loading && <SpinnerBootrap/>}
             <Table 
                centers={centers} 
                getCenters={getCenters} 
                deleteCenter={deleteCenter} 
                totalPages={totalPages} 
                setPage={setPage} 
                page={page} 
                isSearched={isSearched} 
                setIsSearched={setIsSearched}
                setItemsPerPage={setItemsPerPage}
                itemsPerPage={itemsPerPage}
                resetSearch={resetSearch}
                totalCenters={allCenters.length ?? 0}
             />
         </div>
     </div>
 </div>
 )
}

export default Center